import { USER_ROLE } from '../../../store/reducers/session-info.reducer';
import { IDENT_TYPES } from '../../../../features/xt-verification/config';
import { BaseConsentUrlsAdapted } from '../models/base-consent-urls-adapted.model';
import { AdditionalConsentUrlsAdapted } from '../models/additional-consent-urls.model';
import { ConsentUrls } from '../models/consent-urls.model';

export abstract class ConsentLinksMapper {
  static mapPatientConsentLinks(consents: ConsentUrls): BaseConsentUrlsAdapted {
    return {
      imprint: consents?.impressum ?? '',
      termsOfUse: consents?.nutzung_3 ?? '',
      privacyPolicy: consents?.dse_pat ?? '',
      dataProcessing: consents?.dse_info ?? '',
    };
  }

  static mapProviderConsentLinks(
    consents: ConsentUrls,
  ): BaseConsentUrlsAdapted {
    return {
      imprint: consents?.impressum ?? '',
      termsOfUse: consents?.nutzung_3 ?? '',
      privacyPolicy: consents?.dse_prof ?? '',
      dataProcessing: consents?.dse_info ?? '',
    };
  }

  static mapRepresentativeConsentLinks(
    consents: ConsentUrls,
  ): BaseConsentUrlsAdapted {
    return {
      imprint: consents?.impressum ?? '',
      termsOfUse: consents?.nutzung_vertreter ?? '',
      privacyPolicy: consents?.dse_vertreter ?? '',
      dataProcessing: consents?.dse_info ?? '',
    };
  }

  static mapSecondPlatformConsentLinks(
    consents: ConsentUrls,
  ): BaseConsentUrlsAdapted {
    return {
      imprint: consents?.impressum ?? '',
      termsOfUse: consents?.nutzung_2 ?? '',
      privacyPolicy: consents?.dse_nutzer ?? '',
      dataProcessing: consents?.dse_info ?? '',
    };
  }

  static mapAdditionalConsentLinks(
    consents: ConsentUrls,
  ): AdditionalConsentUrlsAdapted {
    return {
      dataTransfer: consents?.datenaustausch ?? '',
      dataSharing: consents?.datenweitergabe ?? '',
      education: consents?.behandlungsinfo ?? '',
      confidentiality: consents?.schweigepflicht ?? '',
      evaluation: consents?.evaluationszwecken ?? '',
      revocation: consents?.hinweistext ?? '',
    };
  }

  static consentLinksByRoleOrIdentType(consents: ConsentUrls) {
    return {
      [USER_ROLE.PRIVATE_RECORD]: this.mapPatientConsentLinks(consents),
      [USER_ROLE.PATIENT]: this.mapPatientConsentLinks(consents),
      [USER_ROLE.PROVIDER]: this.mapProviderConsentLinks(consents),
      [USER_ROLE.DATA_PRIVACY_OFFICER]: this.mapProviderConsentLinks(consents),
      [USER_ROLE.REPRESENTATIVE]: this.mapRepresentativeConsentLinks(consents),
      [IDENT_TYPES.PROFESSIONAL]: this.mapProviderConsentLinks(consents),
    };
  }
}
